import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-overlay-section',
  templateUrl: './overlay-section.component.html',
  styleUrls: ['./overlay-section.component.scss']
})
export class OverlaySectionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
